module.exports = "<span class=\"js-name layout__tab-layout__header-view-item-text\">{{{name}}}</span>\r\n";